

export default [
  {
    path: "/settings/roles-and-privileges",
    name: "RolesAndPrivileges",
    component: () => import("@/views/3pl/Settings/RolesAndPrivileges/index.vue")
   
  },
  {
    path: "/settings/roles-and-privileges/new-role",
    name: "NewRole",
    component: () => import("@/views/3pl/Settings/RolesAndPrivileges/NewRole.vue")
  },
  {
    path: "/settings/roles-and-privileges/edit-role",
    name: "EditRole",
    component: () => import("@/views/3pl/Settings/RolesAndPrivileges/EditRole")
  },
];
